import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  Grid2,
  Typography,
  Box,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { createReservationHB, getData, getDatabyID } from "../api/reserves"; // Supongamos que tienes una función para enviar la reserva
import { differenceInDays } from "date-fns"; // Importamos para cálculo de fechas
import {
  initMercadoPago,
  Wallet,
  CardPayment,
  Payment,
} from "@mercadopago/sdk-react";
import { paymentsCardsFinally } from "../api/pay";
import { useAuth } from "../context/AuthContext";
import { Divider, AppBar, Toolbar, Badge, Fab, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import mppng from "../images/MP.svg";
import { completePay } from "../api/reserves";
import { be } from "date-fns/locale";
const PayPage = () => {
  const [bedsid, setBedsid] = useState("");
  const [totalNights, setTotalNight] = useState("");
  const [ocupants, setOcupants] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [rooms, setRooms] = useState("");
  const [preference, setPreference] = useState("");
  const [initialization, setInitialization] = useState(null);
  const componentRef = useRef(null); // Referencia al componente que vamos a observar
  const navigate = useNavigate();
  const [reservationID, setReservationID] = useState(null);
  const [amountPay, setAmountPay] = useState("");
  const [typePay, setTypePay] = useState(null);
  const [isSeñaChecked, setIsSeñaChecked] = useState(false);

  function parseAmount(seña) {
    // Remover $ y ,
    const cleanValue = seña.replace(/[\$,]/g, "");
    // Convertir a número flotante y luego redondear
    return Math.round(parseFloat(cleanValue));
  }

  useEffect(() => {
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(hash.split("?")[1]);
    const bedsidFromUrl = urlParams.get("bedsid");

    if (!bedsidFromUrl) return;

    const fetchData = async () => {
      try {
        const idjson = { bedsid: bedsidFromUrl };
        const reservation = await getDatabyID(idjson);

        if (!reservation?.data?.reservation) {
          console.error("Datos de reserva no encontrados.");
          return;
        }

        const data = reservation.data.reservation;
        const {
          "nombre habitación": roomName = "",
          "fecha ingr": startDate = "",
          "fecha ret": endDate = "",
          total$: totalPrice = "0",
          seña = "0",
          "c. per": occupants = 0,
          noches: totalNight = 0,
          idbeds: bedsid = "",
          reservationid: reservationId = "",
        } = data;

        if (!roomName || !startDate || !endDate || !bedsid) {
          console.warn("Información incompleta recibida:", data);
          return;
        }

        const señanumb = parseAmount(seña);
        const totalPriceNum = parseAmount(totalPrice);
        const totalhere = seña === "none" ? totalPriceNum : señanumb;
        setRooms(roomName);
        setStartDate(startDate);
        setEndDate(endDate);
        setTotalPrice(totalPriceNum);
        setTypePay(seña === "none" ? true : false);
        setAmountPay(seña === "none" ? totalPriceNum : señanumb);
        setOcupants(occupants);
        setTotalNight(totalNight);
        setBedsid(bedsid);
        setReservationID(reservationId);

        const reservationData = {
          startDate,
          endDate,
          totalPrice: totalhere,
          bedsid,
          rooms: roomName,
        };

        const preference_id = await completePay(reservationData);
        setPreference(preference_id.data.id);
        setInitialization({
          amount: totalhere,
          preferenceId: preference_id.data.id,
        });
      } catch (error) {
        console.error("Error al obtener la reserva:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Inicializar MercadoPago SDK
    initMercadoPago("TEST-bb4206c9-dda5-4b15-8c43-a57f6a395021", {
      locale: "es-AR",
    });
  }, []);

  // Función que maneja el envío de los datos del formulario de pago
  const onSubmit = async ({ formData }) => {
    return new Promise((resolve, reject) => {
      // Llamamos a la función paymentsCards de la API
      if (!bedsid) {
        console.error("Error: reservationID no está disponible");
        return;
      }
      // Estructuramos el payload con los datos del formulario y el reservationID
      const payload = {
        formData,
        bedsid: bedsid, // Usamos el estado aquí
      };
      console.log(payload);
      paymentsCardsFinally(payload)
        .then((response) => {
          navigate("/success"); // Redirige a la página de inicio
          resolve();
        })
        .catch((error) => {
          console.error("Error al procesar el pago", error);
          reject();
        });
    });
  };

  // Función que maneja los errores del Brick
  const onError = (error) => {
    console.log("Error en el Brick: ", error);
  };

  // Función que se llama cuando el Brick está listo para ser usado
  const onReady = () => {
    console.log("El Brick está listo!");
  };

  const scrollToComponent = (componentId) => {
    const element = document.getElementById(componentId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      console.log(`No se encontró un elemento con el ID: ${componentId}`);
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleCheckboxChange = async (event) => {
    const isChecked = event.target.checked;
    setIsSeñaChecked(isChecked);
    const totalhere = isChecked ? amountPay / 2 : amountPay * 2;
    setAmountPay(totalhere);

    const reservationData = {
      startDate,
      endDate,
      totalPrice: totalhere,
      bedsid,
      rooms: rooms,
    };

    const preference_id = await completePay(reservationData);
    setPreference(preference_id.data.id);
    setInitialization({
      amount: totalhere,
      preferenceId: preference_id.data.id,
    });
  };

  const [customization, setCustomization] = useState({
    paymentMethods: {
      creditCard: "all",
      debitCard: "all",
      ticket: "all",
      bankTransfer: "all",
      atm: "all",
      onboarding_credits: "all",
      wallet_purchase: "all",
    },
  });
  return (
    <Box sx={{ backgroundColor: "#ebe4d2" }}>
      <Box sx={{ backgroundColor: "#2F251C" }}>
        <Typography
          color="white"
          sx={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: {
              xs: "1.5rem", // Pantallas pequeñas
              sm: "1.5rem", // Pantallas medianas
              md: "2rem", // Pantallas grandes
              lg: "1.7rem", // Pantallas más grandes
            },
            marginTop: {
              xs: "1.5rem",
              sm: "1.5rem",
              md: "2rem",
              lg: "2.5rem",
            },
            marginLeft: {
              xs: "1.5rem",
              sm: "1.5rem",
              md: "2rem",
              lg: "2.5rem",
            },
          }}
        >
          Pagar y Reservar
        </Typography>
        <Typography
          sx={{
            color: "#fff",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: {
              xs: "1.2rem", // Pantallas pequeñas
              sm: "1.5rem",
              md: "1.3rem",
              lg: "1.3rem",
            },
            padding: {
              xs: "1rem",
              sm: "1rem",
              md: "1rem",
              lg: "1rem",
            },
          }}
          variant="body1"
          gutterBottom
        >
          <strong>Reserva desde </strong>
          {startDate} <strong>Hasta el </strong> {endDate}{" "}
        </Typography>
      </Box>
      <Fab
        size="large" // FAB pequeño
        color="primary"
        sx={{
          position: "fixed",
          top: 16, // Distancia desde la parte superior
          right: 30, // Distancia desde la izquierda
          zIndex: 1000, // Asegura que el FAB esté por encima de otros elementos
        }}
        onClick={() => navigate("/")} // Redirige a la página de inicio
      >
        <HomeIcon />
      </Fab>

      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            width: {
              xs: "90%", // Para pantallas pequeñas, más ancho
              sm: "80%",
              md: "70%",
              lg: "100%", // Para pantallas más grandes
            },
            display: "flex",
            justifyContent: "space-around",
            flexDirection: {
              xs: "column", // Para pantallas pequeñas, más ancho
              sm: "column",
              md: "row",
            },
            padding: "3vh",
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ color: "#333" }}>
            <Box sx={{ padding: "2vh" }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: {
                    xs: "1.2rem", // Pantallas pequeñas
                    sm: "1.5rem",
                    md: "1.3rem",
                    lg: "1.5rem",
                    xl: "1.3rem",
                  },
                }}
              >
                Habitacion: {` ${capitalizeFirstLetter(rooms)}`}
              </Typography>
              <Typography>{` Habitación para ${ocupants} Personas`}</Typography>
              <Typography>$ {totalPrice / ocupants} Por Persona</Typography>
              <Typography>Total de noches: {totalNights}</Typography>
            </Box>
          </Typography>

          <Typography
            variant="body1"
            gutterBottom
            sx={{
              color: "#fff",
              display: {
                xs: "block", // Ocultar en pantallas pequeñas
                sm: "block", // Mostrar en pantallas medianas y grandes
              },
            }}
          >
            <strong>Raspa y gana we</strong>
          </Typography>

          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "20px 0",
              }}
            >
              {typePay ? (
                <Box>
                  {" "}
                  <Checkbox
                    checked={isSeñaChecked}
                    onChange={handleCheckboxChange}
                    inputProps={{
                      "aria-label": "Checkbox para establecer seña",
                    }}
                    color="green"
                  />
                  <Typography
                    style={{ textAlign: "end" }}
                    variant="body1"
                    sx={{
                      color: "black",
                      fontSize: {
                        xs: "1rem", // Pantallas pequeñas
                        sm: "1.2rem",
                        md: "1.2rem",
                        lg: "1.2rem",
                        xl: "1.2rem",
                      },
                    }}
                  >
                    <strong>Señar con el 50% :</strong>
                  </Typography>
                </Box>
              ) : (
                ""
              )}
            </Box>

            <Typography
              style={{ textAlign: "end" }}
              variant="body1"
              sx={{
                color: "black",
                fontSize: {
                  xs: "1.5rem", // Pantallas pequeñas
                  sm: "1.5rem",
                  md: "1.5rem",
                  lg: "1.5rem",
                  xl: "1.2rem",
                },
              }}
            >
              <strong>Precio total:</strong> ${amountPay}
            </Typography>

            <Typography
              style={{ textAlign: "end" }}
              variant="body1"
              sx={{
                color: "grey",
                fontSize: {
                  xs: "1rem", // Pantallas pequeñas
                  sm: "1rem",
                  md: "1rem",
                  lg: "1rem",
                  xl: "1rem",
                },
              }}
            >
              + services
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box>
        {preference ? (
          <Box>
            <Box>
              {preference && (
                <Box>
                  <Grid item xs={12}>
                    <Divider sx={{ margin: "5vh" }}> Metodos de pago </Divider>
                  </Grid>
                  <Payment
                    initialization={initialization}
                    customization={customization}
                    onSubmit={onSubmit}
                    onReady={onReady}
                    onError={onError}
                  />
                </Box>
              )}
            </Box>
          </Box>
        ) : (
          <Box>
            <Box
              sx={{
                justifyContent: "center",
                display: "flex",
                marginTop: "2rem",
                marginBottom: "2rem",
              }}
            >
              <Button
                ref={componentRef}
                variant="contained"
                color="secondary"
                onClick={() => scrollToComponent("form")}
                sx={{
                  padding: "2vh",
                  width: {
                    xs: "70%", // Pantallas pequeñas
                    md: "50%", // Pantallas medianas
                    lg: "53%", // Pantallas grandes
                    xl: "40%", // Pantallas muy grandes
                  },
                  fontSize: {
                    xs: "1rem", // Pantallas pequeñas
                    md: "1rem", // Pantallas medianas
                    lg: "1rem", // Pantallas grandes
                    xl: "1rem", // Pantallas muy grandes
                  },
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
                }}
              >
                Ingresa tus datos
              </Button>
            </Box>
            <Box
              id="form"
              ref={componentRef}
              sx={{
                backgroundColor: "#f0f0f0", // Fondo detrás del formulario
                border: "10px solid #2196f3", // Borde azul
                borderRadius: "8px", // Bordes redondeados
                padding: "24px", // Espacio interno
                marginTop: "24px",
                maxWidth: "800px", // Ancho máximo
                margin: "auto", // Centrar en la página
              }}
            >
              <Typography sx={{ textAlign: "center" }}>
                Ingresar Datos de la Reserva
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PayPage;
